(() => {
  const initFilterToggle = () => {
    console.log("Initializing filter toggle...");

    const toggleComponent = document.querySelector(".filter-header toggle-component");
    if (!toggleComponent) {
      console.warn("Filter toggle: Toggle component not found");
      return;
    }

    const checkInput = toggleComponent.querySelector(".toggle__input--hidden");
    const toggleInput = toggleComponent.querySelector(".toggle__input");
    const verticalFilter = document.querySelector(".products__vertical-filter");

    if (!checkInput || !toggleInput || !verticalFilter) {
      console.warn("Filter toggle: Required elements not found", {
        checkInput: !!checkInput,
        toggleInput: !!toggleInput,
        verticalFilter: !!verticalFilter,
      });
      return;
    }

    console.log("Filter toggle: All required elements found");
    toggleComponent.verticalFilter = verticalFilter;

    const filterState = localStorage.getItem("filterOpen");
    console.log("Filter toggle: Current filter state:", filterState);

    if (filterState === "open") {
      console.log("Filter toggle: Setting initial state to open");
      checkInput.checked = true;
      verticalFilter.classList.remove("products__vertical-filter--hidden");
      toggleInput.classList.add("toggle__input--active");
    } else if (filterState === "close") {
      console.log("Filter toggle: Setting initial state to closed");
      checkInput.checked = false;
      verticalFilter.classList.add("products__vertical-filter--hidden");
      toggleInput.classList.remove("toggle__input--active");
    }

    checkInput.addEventListener("change", (e) => {
      console.log("Filter toggle: Checkbox changed", { checked: e.target.checked });
      if (e.target.checked) {
        verticalFilter.classList.remove("products__vertical-filter--hidden");
        localStorage.setItem("filterOpen", "open");
      } else {
        verticalFilter.classList.add("products__vertical-filter--hidden");
        localStorage.setItem("filterOpen", "close");
      }
    });

    checkInput.addEventListener("change", () => {
      console.log("Filter toggle: Updating toggle input active state", { checked: checkInput.checked });
      toggleInput.classList.toggle("toggle__input--active", checkInput.checked);
    });

    toggleInput.addEventListener("click", (e) => {
      if (e.target === checkInput) return;
      console.log("Filter toggle: Toggle input clicked");
      checkInput.checked = !checkInput.checked;
      checkInput.dispatchEvent(new Event("change"));
    });
  };

  if (document.readyState === "loading") {
    console.log("Filter toggle: Document still loading, waiting for DOMContentLoaded");
    document.addEventListener("DOMContentLoaded", initFilterToggle);
  } else {
    console.log("Filter toggle: Document already loaded, initializing immediately");
    initFilterToggle();
  }

  window.initFilterToggle = initFilterToggle;
})();
